import React, { type ReactElement, type ReactNode } from 'react';

interface Props {
  description: string | number;
  icon: ReactNode;
  type: 'url' | 'tel';
  intentLink?: string;
}

const urlFormatter = (url: string) => {
  if (url.includes('/')) {
    return url.substring(url.lastIndexOf('/') + 1);
  }
  return url;
};

const phoneNumberFormatter = (phone: string) => {
  if (phone.includes('/')) {
    phone.substring(phone.lastIndexOf('/') + 1);

    return phone.substring(phone.lastIndexOf('/') + 1) + '+';
  }

  if (phone.startsWith('98')) {
    return phone + '+';
  }
  return phone;
};

export default function VendorInfoDetailsItem({
  description,
  icon,
  type,
  intentLink,
}: Props): ReactElement {
  const telephoneHrefFormatter = (phone: string) => {
    if (
      !phone.includes('+98') ||
      !phone.includes('021') ||
      !phone.startsWith('0')
    )
      return '+98' + phone;
  };

  return (
    <a
      className="flex items-center justify-center gap-x-2.5 text-xs font-medium text-secondary-400"
      key={description}
      href={
        (intentLink?.length ?? 0) > 0
          ? intentLink
          : type === 'url'
            ? (description as string)
            : `tel:${telephoneHrefFormatter(description as string)}`
      }
      target="_blank"
      rel="noreferrer"
    >
      {type === 'url'
        ? urlFormatter(description as string)
        : phoneNumberFormatter(description as string)}

      <div className="pb-1">{icon}</div>
    </a>
  );
}
